import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import {
  pincodeListAction,
  stateListAction,
} from "../../../redux/actions/general-action";
import { regionSearchListAction } from "../../../redux/actions/settings-action";

const StoreShopAddressTab = ({ disabled = false }) => {
  const dispatch = useDispatch();

  const [stateList, setStateList] = useState([]);
  const [regionList, setRegionList] = useState([]);

  const onSuccessRegion = (data) => {
    setRegionList(
      data?.data?.list.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };

  const onErrorRegion = () => {};

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
    dispatch(regionSearchListAction("", onSuccessRegion, onErrorRegion));
  }, []);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};

  function fetchAddressFn(inputValue, setFieldValue, index, type1, type2) {
    if (inputValue?.length === 6) {
      dispatch(
        pincodeListAction(
          inputValue,
          (response) => {
            if (response?.[0]?.Status === "Error") {
            } else {
              const firstPostOffice = response?.[0]?.PostOffice?.[0];
              // console.log(values[type], "pincode");
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_state`,
                firstPostOffice?.State
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_district`,
                firstPostOffice?.District
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_town`,
                firstPostOffice?.Block
              );

              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_country`,
                firstPostOffice?.Country
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_city`,
                firstPostOffice?.Division
              );

              // cmr_pay_address_city: "",
              // : "",
              // cmr_pay_address_street: "",
              // cmr_pay_address_pincode: "",
              // cmr_pay_address_address: "",
            }
          },
          (data) => {
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_state`, "");
            setFieldValue(
              `${type1}[${index}]cmr_${type2}_address_district`,
              ""
            );
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_town`, "");
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_country`, "");
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_city`, "");
          }
        )
      );
    } else {
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_state`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_district`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_town`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_country`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_city`, "");
    }
  }
  return (
    <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        isDisabled={disabled}
        label="Address "
        placeholder="Street 1"
        name="shop_address"
        id={"shop_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_area"
        placeholder=""
        label="Area"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_landmark"
        placeholder=""
        label="Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_town_or_village"
        placeholder=""
        label="Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_city"
        placeholder=""
        label="City"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        placeholder={"Select state"}
        options={stateList}
        label={"State"}
        id={"shop_state"}
        name="shop_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      <SelectField
        isDisabled={disabled}
        // isRequired={true}
        placeholder={"Select country"}
        options={countryList}
        label={"Country"}
        id={"shop_country_region"}
        name="shop_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        // isRequired={true}
        placeholder={"Select region"}
        options={regionList}
        label={"Region"}
        id={"shop_region"}
        name="shop_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_pin_code"
        placeholder=""
        label="Pin Code"
        labelWidth="8.5rem"
      />
    </div>
  );
};

export default StoreShopAddressTab;

const countryList = [{ label: "India", value: "india" }];
